module.exports = __webpack_public_path__ + "img/Apoptosis-SCC_GSE144240.0d3e5de0.png";